import { motion } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { DIMENSIONS } from "@/lib/site-data";

export const Dimensions = () => (
  <section id="dimensions" className="relative mx-auto max-w-[1400px] px-6 py-24 lg:px-12 lg:py-32">
    <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
      <div>
        <p className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-avatar-red">
          (Dimensions)
        </p>
        <h2 className="max-w-2xl font-heading text-4xl font-bold leading-none tracking-tighter text-avatar-ink md:text-6xl">
          Engineered for strength.<br />Designed for every need.
        </h2>
      </div>
      <p className="max-w-xs text-sm leading-relaxed text-avatar-ink/55">
        Seven capacities from 500 to 5000 litres — a perfect fit for homes,
        apartments and commercial rooftops.
      </p>
    </Reveal>

    <Reveal delay={0.1}>
      <div className="overflow-hidden rounded-3xl border border-avatar-ink/10">
        {/* header */}
        <div className="grid grid-cols-4 bg-avatar-navy px-6 py-5 text-xs font-bold uppercase tracking-[0.15em] text-white/80 md:px-10">
          <span>Capacity</span>
          <span className="text-center">Height</span>
          <span className="text-center">Width</span>
          <span className="text-right">Fits</span>
        </div>
        {DIMENSIONS.map((d, i) => (
          <motion.div
            key={d.litre}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.05 }}
            data-testid={`dimension-row-${d.litre}`}
            className="group grid grid-cols-4 items-center border-t border-avatar-ink/8 px-6 py-6 transition-colors duration-300 hover:bg-avatar-ink/[0.03] md:px-10"
          >
            <div className="flex items-baseline gap-1">
              <span className="font-heading text-2xl font-bold text-avatar-ink transition-colors group-hover:text-avatar-red md:text-3xl">
                {d.litre.toLocaleString()}
              </span>
              <span className="text-xs text-avatar-ink/40">L</span>
            </div>
            <span className="text-center font-heading text-lg text-avatar-ink/80">{d.height}&Prime;</span>
            <span className="text-center font-heading text-lg text-avatar-ink/80">{d.width}&Prime;</span>
            <span className="text-right text-xs text-avatar-ink/40">
              {d.litre <= 1000 ? "Small Home" : d.litre <= 2000 ? "Family Home" : "Commercial"}
            </span>
          </motion.div>
        ))}
      </div>
    </Reveal>
  </section>
);
